// extracted by mini-css-extract-plugin
export default {"screenWrap":"StudentServicesStaff_screenWrap__m5ryM","expandedSidebar":"StudentServicesStaff_expandedSidebar__nsz6T","hidden":"StudentServicesStaff_hidden__WT4c9"};